import { Component } from "preact";
import style from "./style.css";
import YearSelector from "../../../../components/yearSelector";
import HomeMapWithTabs from "../../../../components/home-map-with-tabs";
import TmpHomeFinancialComponent from "../../../tmp_home_financial_component";
import { formatNumber, formatNumberNoFractionDigits } from "../../../../utils";

class Main extends Component {
  render() {
    const {
      headerSelectedYear,
      onSelectHeaderYear,
      isLoadingYearSummary,
      yearSummaryData,
    } = this.props;
    return (
      <div className={style.mainWrapper}>
        <div className={style.headerWrapper}>
          <div className={style.headerNavbarWrapper}>
            <div>
              <img
                src="/static/assets/images/home_logo.png"
                alt="United Nations"
              />
            </div>
            <div>
              <ul>
                <li>
                  <a
                    alt="United Nations"
                    href="/"
                    className={style.headerActiveLink}
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a alt="Activities" href="/projects">
                    Activities
                  </a>
                </li>
                <li>
                  <a alt="Donors" href="/donors">
                    Donors
                  </a>
                </li>
                <li>
                  <a alt="Sectors" href="/sustainable-development-goals">
                    Sectors
                  </a>
                </li>
              </ul>
            </div>
            <div style={{ display: "none" }}>
              <button>
                <i className="fas fa-search" />
              </button>
            </div>
          </div>
          <div className={style.headerColumns}>
            <div>
              <div className={style.headerFirstWrapper}>
                <span>unrwa transparency portal</span>
                <p>
                  UNRWA is a United Nations agency established by the General
                  Assembly in 1949 and mandated to provide assistance and
                  protection to 5.7 million Palestine refugees registered with
                  the Agency in Jordan, Lebanon, Syria, West Bank, including
                  East Jerusalem and the Gaza Strip to achieve their full human
                  development potential, pending a just and lasting solution to
                  their plight.
                </p>
                <div
                  className={style.headerSearchBar}
                  style={{ display: "none" }}
                >
                  <input
                    type="text"
                    placeholder="Search Activities, Donors, Recipients and more"
                  />
                  <i className="fas fa-search" />
                </div>
              </div>
            </div>
            <div>
              <div className={style.headerSecondWrapper}>
                <YearSelector
                  selectedYear={headerSelectedYear}
                  onSelectYear={onSelectHeaderYear}
                />
                {isLoadingYearSummary ? (
                  <div className={style.headerCountersLoadingWrapper}>
                    <i className="fas fa-spinner" />
                  </div>
                ) : (
                  <div>
                    <div className={style.headerCountersWrapper}>
                      <div>
                        <b>
                          {formatNumber(yearSummaryData.budgets / 1000000)}m
                        </b>
                        <span>Budget</span>
                      </div>
                      <div>
                        <b>
                          {formatNumber(yearSummaryData.expenses / 1000000)}m
                        </b>
                        <span>Expense</span>
                      </div>
                    </div>
                    <div className={style.headerCountersWrapper}>
                      <div>
                        <b>
                          {formatNumberNoFractionDigits(
                            yearSummaryData.activities
                          )}
                        </b>
                        <span>Activities</span>
                      </div>
                      <div>
                        <b>
                          {formatNumberNoFractionDigits(yearSummaryData.donors)}
                        </b>
                        <span>Donors</span>
                      </div>
                    </div>
                  </div>
                )}
                <p className={style.headerCountersInformation}>
                  * The donor count includes only donors who have already
                  provided consent to publish contributions to the IATI web
                  portal.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: "3rem", marginBottom: "3rem" }}>
          <HomeMapWithTabs />
          <TmpHomeFinancialComponent />
        </div>
        <div className={style.listSectionWrapper}>
          <div className={style.listMainTitleWrapper}>
            <h1>Making an impact</h1>
            <p>
              UNRWA is a United Nations agency established by the General
              Assembly in 1949 and mandated to provide assistance and protection
              to 5.7 million Palestine refugees registered with the Agency in
              Jordan, Lebanon, Syria, West Bank, including East Jerusalem and
              the Gaza Strip to achieve their full human development potential,
              pending a just and lasting solution to their plight.
            </p>
          </div>
          <div className={style.listColumnsWrapper}>
            <div>
              <div className={style.listTitleWrapper}>
                <i className="fas fa-medkit" />
                <span>Health</span>
              </div>
              <p>
                Over 3 million refugees accessing our health services with more
                than 8 million annual patient visits.
                <a
                  href="https://www.unrwa.org/what-we-do/health"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  More information
                </a>
                .
              </p>
            </div>
            <div>
              <div className={style.listTitleWrapper}>
                <i className="fas fa-user-shield" />
                <span>Protection</span>
              </div>
              <p>
                5.7 million refugees covered by our protection mandate.
                <a
                  href="https://www.unrwa.org/what-we-do/protection"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  More information
                </a>
                .
              </p>
            </div>
            <div>
              <div className={style.listTitleWrapper}>
                <i className="fas fa-piggy-bank" />
                <span>Microfinance</span>
              </div>
              <p>
                Over 475,000 microfinance loans awarded to provide sustainable
                income-generation opportunities for Palestine refugees.
                <a
                  href="https://www.unrwa.org/what-we-do/microfinance"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  More information
                </a>
                .
              </p>
            </div>
          </div>
          <div className={style.listColumnsWrapper}>
            <div>
              <div className={style.listTitleWrapper}>
                <i className="fas fa-user-tie" />
                <span>Vocational training</span>
              </div>
              <p>
                Percentage of UNRWA vocational training students who secure jobs
                after graduation 80%.
                <a
                  href="https://www.unrwa.org/what-we-do/vocational-training?program=33"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  More information
                </a>
                .
              </p>
            </div>
            <div>
              <div className={style.listTitleWrapper}>
                <i className="fas fa-graduation-cap" />
                <span>Education</span>
              </div>
              <p>
                Over 500,000 students enrolled at UNRWA schools.
                <a
                  href="https://www.unrwa.org/what-we-do/education"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  More information
                </a>
                .
              </p>
            </div>
            <div>
              <div className={style.listTitleWrapper}>
                <i className="fas fa-campground" />
                <span>Infrastructure and Camp Improvement</span>
              </div>
              <p>
                Infrastructure and Camp Improvement in the 58 official Palestine
                refugee camps in Jordan, Lebanon, Syria, the West Bank and the
                Gaza Strip.
                <a
                  href="https://www.unrwa.org/what-we-do/infrastructure-camp-improvement"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  More information
                </a>
                .
              </p>
            </div>
          </div>
        </div>
        <div className={style.footerSectionWrapper}>
          <img src="/static/assets/images/home_logo.png" alt="United Nations" />
          <ul>
            <li>
              <a alt="United Nations" href="https://www.unrwa.org/">
                About us
              </a>
            </li>
            <li>
              <a
                alt="United Nations"
                href="https://www.un.org/sustainabledevelopment/sustainable-development-goals/"
              >
                Sustainable Development Goals
              </a>
            </li>
            <li>
              <a alt="United Nations" href="mailto:iati@unrwa.org">
                Contact us
              </a>
            </li>
          </ul>
          <p>
            Copyright © United Nations Relief and Works Agency for Palestine
            Refugees in the Near East
          </p>
        </div>
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./routes/home/components/main/index.js